import type { Voucher } from '#src/interfaces/voucher'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useVoucherStore = defineStore('voucherStore', () => {
  const voucher = ref<Voucher | null>(null)
  const voucherPin = ref<string | null>(null)

  const setVoucher = (newVoucher: Voucher | null) => {
    voucher.value = newVoucher
  }

  const setVoucherPin = (pin: string | null) => {
    voucherPin.value = pin
  }

  const clearVoucherData = () => {
    voucher.value = null
    voucherPin.value = null
  }

  return {
    voucher,
    voucherPin,
    setVoucher,
    setVoucherPin,
    clearVoucherData
  }
})
